const urlName = '/usercenter/v1/account'

export default API => ({
    /**
     * 账号登录
     * @param { account: 账号, password: 密码 }  param2
     * 响应数据data：  用户token，用于标识用户的登录状态信息。
     */
    postAccountLogin({ params, data }) { 
        return API({ url: `${urlName}/login`, method:'post', params, data });
    },
    /**
     * 验证码登录
     * @param { account: 账号, authCode: 密码 } param2
     * 响应数据data：  用户token，用于标识用户的登录状态信息。
     */
    postAccountLoginByAuthCode({params, data}) {
        return API({ url: `${urlName}/loginByAuthCode`, method:'post', params, data });
    },
    /**
     * 注销登录
     * @param { token: 用户token } param1
     * 响应数据data：  boolean   注销登录的结构，true 成功；false 失败
     */
    postAccounLogout({ params, data }) {
        return API({ url: `${urlName}/logout`, method:'post', params, data });
    },
    /**
     * 获取验证码
     * @param { phone: 手机号 } param1
     * 响应数据data：  boolean   是否发送验证码成功，true 成功；false
     */
    postAccountGetAuthCode({ params, data }) {
        return API({ url: `${urlName}/getAuthCode`, method:'post', params, data });
    },
    /**
     * 企业注册获取验证码
     * @param {  } 
     * 响应数据data：  boolean   是否发送验证码成功，true 成功；false
     */
    getAuthCodeCommon ({ params, data }) {
        return API({ url: '/usercenter/v1/account/getAuthCodeCommon', method: 'post', params, data });
    },
    /**
     * 修改密码
     * @param { password: 原密码, passwordNew: 新密码 } param2
     * 响应数据data：  boolean   修改密码的结果，true 成功；false 失败
     */
    postAccountChangePassword({ params, data }) {
        return API({ url: `${urlName}/changePassword`, method:'post', params, data });
    },
    /**
     * 重置密码
     * @param { password: 新密码, authCode: 验证码 } param1
     * 响应数据data：  boolean   是否发送验证码成功，true 成功；false
     */
    postAccountResetPassword({ params, data }) {
        return API({ url: `${urlName}/resetPassword`, method:'post', params, data });
    },
    /**
     * 重置密码
     * @param { phone: 手机号, password: 新密码, authCode: 验证码 } param1
     * 响应数据data：  boolean   是否发送验证码成功，true 成功；false
     */
    postAccountResetPasswordNew( data ) {
        return API({ url: `${urlName}/resetPasswordNew`, method:'post', data });
    },
    /**
     * 注册
     * @param { password: 密码, account: 账号, authCode: 验证码 } param1
     * 响应数据data：  boolean   修改密码的结果，true 成功；false 失败
     */
    postAccountRegister({ params, data }) {
        return API({ url: `${urlName}/register`, method:'post', params, data });
    },
    /**
     * 企业注册
     * @param {password: 密码, phone: 手机号, authCode: 验证码} param1 
     * @returns 
     */
     postCompanyRegister({ params, data }) {
        return API({ url: `${urlName}/registerCompany`, method:'post', params, data });
    },
    /**
     * 获取用户组织
     * @param { }  param0
     * 响应数据 组织列表。
     */
    getFindOrganList ({ params, data }) {
        return API({ url: `${urlName}/findOrganList`, params, data });
    },
    /**
     * 获取用户分校
     * @param { }  param0
     * 响应数据 用户分校列表。
     */
    getFindAdminBranchList ({ params, data }) {
        return API({ url: `${urlName}/findAdminBranchList`, params, data });
    },
    /**
     * 判断是否需要修改密码
     * 响应数据 是否需要修改密码。
     */
    checkPasswordTime () {
        return API({ url: `${urlName}/checkPasswordTime` });
    },
    // 一键实施默认登录
    demoLogin(data){
        return API({ url: `/usercenter/v1/account/demo/login`, method:'post', data });
    }
})